import { Component, inject } from '@angular/core';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MenuComponent } from '../../components/Controls/menu/menu.component';
import { PgfHowItWorksComponent } from './how-it-works/how-it-works.component';
import { PgfPieComponent } from './pie/pie.component';
import { RouterLink } from '@angular/router';
import { NewsComponent } from '../../components/Controls/News/news.component';
import { AdvisorContactComponent } from '../shared/advisor-contact.component';

@Component({
    templateUrl: './pgf-resources.component.html',
    styleUrls: ['pgf-resources.component.scss'],
    imports: [MenuComponent, PgfHowItWorksComponent, PgfPieComponent, RouterLink, NewsComponent, AdvisorContactComponent]
})
export class PgfResourcesComponent {
  modalService = inject(NgbModal);
}